import React, { useState } from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';
import './SpinnerOverlay.scss';

const SpinnerOverlay = () => {
  return (
    <div className="progress-spinner-container">
      <ProgressSpinner style={{ marginLeft: '90px' }} />
    </div>
  );
};

export default SpinnerOverlay;
